module.exports = __webpack_public_path__ + "static/media/facebook-white.7eaa4d70.svg";